export const INFRA = 'infra';
export const SESSION = 'session';
export const ENVIRONMENT = 'environment';
